var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSnowman(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 61,
    viewBox: "0 0 34 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17447_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 34.6507C23.6279 34.6507 29.0008 29.2778 29.0008 22.6499C29.0008 16.022 23.6279 10.6491 17 10.6491C10.3721 10.6491 4.99918 16.022 4.99918 22.6499C4.99918 29.2778 10.3721 34.6507 17 34.6507Z",
    fill: "#EAE6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 60.2974C26.3888 60.2974 34 52.6862 34 43.2974C34 33.9085 26.3888 26.2974 17 26.2974C7.61116 26.2974 0 33.9085 0 43.2974C0 52.6862 7.61116 60.2974 17 60.2974Z",
    fill: "#EAE6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M26.9021 29.482C27.9377 31.6768 28.5151 34.1283 28.5151 36.7173C28.5151 46.1062 20.904 53.7173 11.5151 53.7173C7.82182 53.7173 4.4035 52.5351 1.61293 50.5326C4.33018 56.3016 10.1954 60.3019 17 60.3019C26.3889 60.3019 34 52.6909 34 43.3019C34 37.6062 31.1957 32.5704 26.9021 29.4865V29.482Z",
    fill: "#B7B3B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M5.62237 18.8375C8.48625 19.5019 12.5232 19.9143 17 19.9143C21.4768 19.9143 25.5137 19.5019 28.3776 18.8375C26.783 14.0811 22.2924 10.6537 17 10.6537C11.7075 10.6537 7.21698 14.0811 5.62237 18.8375Z",
    fill: "#B7B3B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3744 35.031C30.5175 35.5305 29.3078 36.1491 27.7865 36.7356C26.0544 37.4 23.9146 38.0049 21.4218 38.3256C16.4822 38.9534 10.1496 38.4356 2.85471 34.8982C1.93369 34.4537 1.63126 33.2715 2.23153 32.4467C3.43207 30.7925 4.90296 29.3537 6.58005 28.1806L6.67169 28.2356C6.67169 28.2356 12.3582 31.0858 21.4218 29.8348C23.1356 29.5965 24.973 29.2116 26.9113 28.6343C27.2 28.5472 27.5024 28.5426 27.7865 28.6159C28.0202 28.6709 28.2402 28.7809 28.428 28.9367C29.7523 29.9998 30.9253 31.2461 31.9059 32.6345C32.4741 33.4318 32.2175 34.5453 31.3744 35.0356V35.031Z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1801 38.4448C22.6178 38.2431 24.7531 37.7528 26.5447 37.1663V28.7305C24.2674 29.3857 22.1367 29.7752 20.1801 29.9768V38.4493V38.4448Z",
    fill: "#D81D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7655 47.6962C21.5776 47.6962 21.4264 47.545 21.4264 47.3571V42.807H22.1092V47.3571C22.1092 47.545 21.958 47.6962 21.7701 47.6962H21.7655Z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.186 47.6962C22.9981 47.6962 22.8469 47.545 22.8469 47.3571V42.807H23.5296V47.3571C23.5296 47.545 23.3784 47.6962 23.1906 47.6962H23.186Z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6019 47.6962C24.414 47.6962 24.2628 47.545 24.2628 47.3571V42.807H24.9456V47.3571C24.9456 47.545 24.7943 47.6962 24.6065 47.6962H24.6019Z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0224 47.6962C25.8345 47.6962 25.6833 47.545 25.6833 47.3571V42.807H26.366V47.3571C26.366 47.545 26.2148 47.6962 26.027 47.6962H26.0224Z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4429 47.6962C27.255 47.6962 27.1038 47.545 27.1038 47.3571V42.807H27.7865V47.3571C27.7865 47.545 27.6353 47.6962 27.4474 47.6962H27.4429Z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6984 21.3806C11.6984 20.7758 11.2081 20.2809 10.5986 20.2809C9.98921 20.2809 9.49892 20.7712 9.49892 21.3806C9.49892 21.9901 9.98921 22.4804 10.5986 22.4804C11.2081 22.4804 11.6984 21.9901 11.6984 21.3806Z",
    fill: "#008665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2032 21.3806C24.2032 20.7758 23.7129 20.2809 23.1035 20.2809C22.4941 20.2809 22.0038 20.7712 22.0038 21.3806C22.0038 21.9901 22.4941 22.4804 23.1035 22.4804C23.7129 22.4804 24.2032 21.9901 24.2032 21.3806Z",
    fill: "#008665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7984 26.6044C17.8942 26.6044 18.7825 25.7161 18.7825 24.6203C18.7825 23.5245 17.8942 22.6362 16.7984 22.6362C15.7026 22.6362 14.8143 23.5245 14.8143 24.6203C14.8143 25.7161 15.7026 26.6044 16.7984 26.6044Z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7819 28.6113V43.6456H21.4173V29.8302C23.131 29.5919 24.9685 29.207 26.9067 28.6297C27.1954 28.5426 27.4978 28.538 27.7819 28.6113Z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3003 39.21C19.3003 38.0278 18.3426 37.0701 17.1604 37.0701C15.9782 37.0701 15.0205 38.0278 15.0205 39.21C15.0205 40.3922 15.9782 41.3499 17.1604 41.3499C18.3426 41.3499 19.3003 40.3922 19.3003 39.21Z",
    fill: "#008665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3003 45.5793C19.3003 44.3971 18.3426 43.4394 17.1604 43.4394C15.9782 43.4394 15.0205 44.3971 15.0205 45.5793C15.0205 46.7615 15.9782 47.7192 17.1604 47.7192C18.3426 47.7192 19.3003 46.7615 19.3003 45.5793Z",
    fill: "#008665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3003 51.5682C19.3003 50.386 18.3426 49.4283 17.1604 49.4283C15.9782 49.4283 15.0205 50.386 15.0205 51.5682C15.0205 52.7504 15.9782 53.7081 17.1604 53.7081C18.3426 53.7081 19.3003 52.7504 19.3003 51.5682Z",
    fill: "#008665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8566 15.6071C30.8566 17.2933 24.6523 18.6588 17 18.6588C9.34771 18.6588 3.1434 17.2933 3.1434 15.6071C3.1434 13.9208 9.34771 12.5553 17 12.5553C24.6523 12.5553 30.8566 13.9208 30.8566 15.6071Z",
    fill: "#008665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2469 15.0664L24.8631 0.866094H24.8539C24.8402 0.389544 21.3256 0.00463867 16.9908 0.00463867C12.6561 0.00463867 9.12775 0.394127 9.12775 0.870676L7.74393 15.0664C13.655 16.409 19.7814 16.4456 25.7108 15.1809L26.2423 15.0664H26.2469Z",
    fill: "#008665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7154 10.9653C19.9234 12.2025 13.9391 12.1887 8.15175 10.9378L7.74851 15.0663C13.6596 16.4089 19.786 16.4456 25.7154 15.1809L26.2469 15.0663L25.8437 10.9378L25.7154 10.9653Z",
    fill: "#04664C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17447_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 60.2973,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowman);
export default __webpack_public_path__ + "static/media/snowman.fe07ccf4.svg";
export { ForwardRef as ReactComponent };